export const getProjectNavigationPath = (caseId, isValidator = false, validationQueue = '') => {
  const normalizedCaseId = String(caseId ?? '').trim();
  if (!normalizedCaseId) {
    return isValidator ? '/validate' : '/';
  }

  const basePath = isValidator ? '/validate' : '/case';
  const normalizedQueue = validationQueue === 'split' || validationQueue === 'normal'
    ? validationQueue
    : '';
  return `${basePath}/${encodeURIComponent(normalizedCaseId)}${normalizedQueue ? `?queue=${normalizedQueue}` : ''}`;
};
